module.exports = __webpack_public_path__ + "img/QR-3999.619a82ac.png";